import { Control, Controller } from "react-hook-form"
import SubdivisonCode from "./SubdivisionCode"
import { getMaskedFieldRules } from "../../../helpers/validationRules"
import { IDataCollectionStandardConfig } from "@piceasoft/core"
import { TContractData } from "../../../../../dataCollectionTypes"

type TProps = {
    config?: IDataCollectionStandardConfig
    errorMessage: string
    fieldValue?: string
    control: Control<TContractData, object>,
}

const SubdivisonCodeController: React.FunctionComponent<TProps> = (props: TProps) => {
    let {config, control, fieldValue, errorMessage} = props
    return (
        <Controller
            name="passport.subdivisionCode"
            control={control}
            rules={getMaskedFieldRules(fieldValue)}
            render={({ field }) =>
                <SubdivisonCode
                    config={config}
                    value={field.value}
                    errorMessage={errorMessage}
                    handleOnBlur={field.onBlur}
                    handleOnChange={(value: string) => {
                        field.onChange(value)
                    }}
                />
            }
        />
    )
}

export default SubdivisonCodeController